import SectionHeader from './SectionHeader';

const testimonials = [
  {
    name: '阿远',
    role: '追更党',
    text: '飞飞漫画网翻页是真的流畅，晚上躺着用夜间模式追更，眼睛舒服多了，追更体验拉满。',
    avatar: 'ri-user-3-fill',
  },
  {
    name: '小鹿',
    role: '学生党',
    text: '加载速度超快，打开就是图，一点不卡顿。分类也很全，找漫画特别方便。',
    avatar: 'ri-user-heart-fill',
  },
  {
    name: '老白',
    role: '资深漫迷',
    text: '极速加载不等待，翻页丝滑不卡顿，夜间模式护眼很贴心，是我用得最顺手的漫画站。',
    avatar: 'ri-user-4-fill',
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-start gap-10 lg:grid-cols-2">
          <div>
            <SectionHeader
              eyebrow="关于我们"
              title="热爱漫画，更懂阅读"
              desc="飞飞漫画网始终把阅读体验放在第一位，专注打磨极速加载、翻页流畅与夜间模式护眼三大能力，只为让你随时随地畅快看漫画。"
            />
            <div className="mt-7 grid grid-cols-2 gap-4">
              {[
                { num: '2019', label: '创立于' },
                { num: '3万+', label: '作品收录' },
                { num: '99.9%', label: '加载成功率' },
                { num: '7×24', label: '极速更新' },
              ].map((s) => (
                <div
                  key={s.label}
                  className="rounded-lg border border-background-200 bg-background-50 p-4"
                >
                  <div className="font-heading text-2xl text-primary-600">{s.num}</div>
                  <div className="mt-1 text-xs text-foreground-600">{s.label}</div>
                </div>
              ))}
            </div>
            <div className="mt-6 flex flex-wrap items-center gap-3 text-sm text-foreground-600">
              <span className="flex items-center gap-1.5">
                <i className="ri-mail-line text-primary-500"></i>
                <a href="mailto:hello@feifeimanga.cn" className="hover:text-primary-600 transition-colors">
                  hello@feifeimanga.cn
                </a>
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-time-line text-primary-500"></i>
                全天候在线
              </span>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wide text-foreground-500">漫画爱好者的真实口碑</h3>
            <div className="mt-4 space-y-4">
              {testimonials.map((t) => (
                <figure
                  key={t.name}
                  className="rounded-lg border border-background-200 bg-background-50 p-5"
                >
                  <div className="flex items-center gap-2 text-accent-500">
                    {[1, 2, 3, 4, 5].map((n) => (
                      <i key={n} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                  <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">
                    “{t.text}”
                  </blockquote>
                  <figcaption className="mt-4 flex items-center gap-3">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                      <i className={`${t.avatar} text-lg`}></i>
                    </span>
                    <div>
                      <div className="text-sm font-bold text-foreground-950">{t.name}</div>
                      <div className="text-xs text-foreground-600">{t.role}</div>
                    </div>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}